import { render, staticRenderFns } from "./drugDetail.vue?vue&type=template&id=059da634&scoped=true&"
import script from "./drugDetail.vue?vue&type=script&lang=js&"
export * from "./drugDetail.vue?vue&type=script&lang=js&"
import style0 from "./drugDetail.vue?vue&type=style&index=0&id=059da634&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059da634",
  null
  
)

export default component.exports